import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineService } from '../proxy/general/controllers/machine.service';
import { MovilizationTypeService } from '../proxy/general/controllers/movilization-type.service';
import { MachineHeaderChangeHistoric } from '@general/machine-header-change-historic/machine-header-change-historic';

FieldBuilder.setNamespace('General');

export const FELLER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isHerbicideApplicator', 'Entity.Feller.IsHerbicideApplicator')
    .build(),
  FieldBuilder
    .foreignKey('movilizationTypeId', 'Entity.MovilizationType', MovilizationTypeService)
    .displayFromNested('movilizationType.name')
    .build(),
  FieldBuilder
    .foreignKey('machineId', 'Entity.Machine', MachineService)
    .required()
    .displayFromNested('machine.name')
    .keyField('machine.name')
    .hideInChildForms()
    .build(),
];

export const FELLER_CONFIG = {
  entityName: 'Feller',
  localizationKey: 'General::Entity.Feller',
  fields: FELLER_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Fellers',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'MachineHeaderChangeHistoric',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.MachineHeaderChangeHistoric',
        component: MachineHeaderChangeHistoric,
      },
  ]
};
